import React, {Component} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import Documents from "../components/Documents";
import ActionLink from "../../../../controls/ActionLink";
import Moment from "react-moment";
import {OverlayTrigger} from "react-bootstrap";
import ShareUrlPopover from "../../popovers/ShareUrlPopover";
import PdfViewerModal from "../../../../modals/PdfViewerModal";

class ArchivedTenderRequest extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };
    static defaultProps = {};
    state = {
        showSpecificationModal: false,
        specificationId: null
    };

    render() {
        const {data} = this.props;
        return (
            <div className={`panel ${data.hasProblem ? "panel-danger" : ""}`}>
                <div className="panel-heading">
                    <span className="panel-title">
                        <Link to={`/tenders/${this.props.data.tenderId}`}>
                            <strong>№ {data.tenderNumber}</strong>
                        </Link>
                        {" "}
                        <small><Moment locale="ru" format="DD.MM.YYYY HH:mm">{data.createdAt}</Moment></small>
                    </span>
                    <div className="panel-heading-controls">
                        {/*<div className="panel-heading-text text-default">*/}
                        {/*<span className="panel-heading-text">*/}
                        {/*<i className="fa fa-comment-o"/> {data.totalCommentCount}*/}
                        {/*{*/}
                        {/*data.newCommentCount*/}
                        {/*? <span> (<strong className="text-success">{data.newCommentCount}</strong>)</span>*/}
                        {/*: null*/}
                        {/*}*/}
                        {/*{data.hasProblem && <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>}*/}
                        {/*</span>*/}
                        {/*</div>*/}
                        {
                            data.hasProblem &&
                            <span className="label label-danger">Возникла проблема</span>
                        }
                        <OverlayTrigger ref={el => this.shareUrlPopoverOverlay = el}
                                        trigger="click" placement="top"
                                        rootClose
                                        overlay={<ShareUrlPopover
                                            url={`${window.location.origin}/tenders/${this.props.data.tenderId}`}
                                            close={() => this.shareUrlPopoverOverlay.hide()}/>}>
                            <button type="button" className="btn btn-default btn-xs btn-outline btn-outline-colorless">
                                <i className="fa fa-link"/> Ссылка
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
                {
                    data.hasProblem &&
                    <div className="px-block-alerts">
                        <div className="alert alert-danger">
                            Текст проблемы
                        </div>
                    </div>
                }
                <div className="panel-body" style={{position: 'relative'}}>
                    <div className="row">
                        <div className="col-sm-9">
                            {data.items.map((item, i) =>
                                <div key={item.id} className={`row ${i > 0 ? "m-t-1" : ""}`}>
                                    <div className="col-sm-9">
                                        <strong className="font-size-14">{item.name}</strong>
                                        <div className="m-l-1 m-t-1">
                                            <div className="row">
                                                <div className="col-sm-4">Статус</div>
                                                <div className="col-sm-8">
                                                    {data.status}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Кол-во</div>
                                                <div className="col-sm-8">
                                                    <strong>{item.count}</strong> шт.
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Факт. принятое кол-во</div>
                                                <div className="col-sm-8">
                                                    {
                                                        item.countFact
                                                            ? <span><strong>{item.countFact}</strong> шт.</span>
                                                            : "Не указано"
                                                    }
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Дата доставки</div>
                                                <div className="col-sm-8">
                                                    <b>
                                                        <Moment locale="ru"
                                                                format="DD.MM.YYYY">
                                                            {data.deliveryDate}
                                                        </Moment>
                                                    </b>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Адрес доставки</div>
                                                <div className="col-sm-8">{data.deliveryAddress}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Доставка</div>
                                                <div className="col-sm-8">{data.deliveryTypeName}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Клиент</div>
                                                <div className="col-sm-8">{data.payer}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Условия оплаты</div>
                                                <div className="col-sm-8">{data.paymentConditions}</div>
                                            </div>
                                            <div className="row m-t-1">
                                                <div className="col-sm-12">
                                                    {
                                                        item.specDocumentId &&
                                                        <div>
                                                            <i className="fa fa-file-pdf-o"/>
                                                            &nbsp;
                                                            <ActionLink onClick={() => this.showSpecification(item)}>
                                                                Посмотреть требования к паллетам
                                                            </ActionLink>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="row">
                                            <div className="col-sm-10 col-sm-offset-2">
                                                {
                                                    item.providerRate &&
                                                    <div>
                                                        <strong className="font-size-20">{item.providerRate}&nbsp;р.</strong> без НДС
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-md-3 font-size-14">
                            <div>
                                {/*<OverlayTrigger ref="driverPopoverOverlay"*/}
                                                {/*trigger="click" placement="left"*/}
                                                {/*rootClose*/}
                                                {/*overlay={<DriverPopover*/}
                                                    {/*data={{*/}
                                                        {/*driver: this.state.driver,*/}
                                                        {/*driverPhoneNumber: this.state.driverPhoneNumber,*/}
                                                        {/*vehicle: this.state.vehicle*/}
                                                    {/*}}*/}
                                                    {/*onSave={driverData => this.updateDriverData(driverData)}*/}
                                                    {/*close={() => this.refs.driverPopoverOverlay.hide()}/>}>*/}
                                    {/*<ActionLink>*/}
                                        {/*{!this.state.driver && <i className="fa fa-warning"/>} Данные водителя*/}
                                    {/*</ActionLink>*/}
                                {/*</OverlayTrigger>*/}
                            </div>
                            <div className="m-t-1">
                            </div>
                        </div>
                    </div>
                    {
                        data.type.id === 1 &&
                        <span class="label label-primary label-ribbon label-ribbon-bottom right">
                            Покупка
                        </span>
                    }
                    {
                        data.type.id === 2 &&
                        <span class="label label-danger label-ribbon label-ribbon-bottom right">
                            Продажа
                        </span>
                    }
                </div>
                <div className="panel-footer">
                    <Documents entityId={data.tenderId} entityName="Tender" propertyName="SupplierDocuments"/>
                </div>
                <PdfViewerModal documentId={this.state.specificationId}
                                show={this.state.showSpecificationModal}
                                onHide={() => this.setState({showSpecificationModal: false})}/>
            </div>
        );
    }

    showSpecification(item) {
        this.setState({
            showSpecificationModal: true,
            specificationId: item.specDocumentId
        });
    }
}

export default ArchivedTenderRequest;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/TenderRequests/Archived/ArchivedTenderRequest.js